const warningDueStatement = {
  'warningDueStatement.label': 'Valor fechado',
  'warningDueStatement.dueDays': 'Dias atrasados',
};

export default warningDueStatement;
